import { render } from "./branch-details.vue?vue&type=template&id=3664733e&scoped=true"
import script from "./branch-details.vue?vue&type=script&lang=js"
export * from "./branch-details.vue?vue&type=script&lang=js"

import "./branch-details.vue?vue&type=style&index=0&id=3664733e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3664733e"]])

export default __exports__